import React from "react";
import { CardText, Wrapper } from "./styled";

export default function AssuranceSelector({
  options,
  selected,
  setSelectedOption,
}) {
  return (
    <Wrapper
      style={{ borderRadius: options.border }}
      selected={selected}
      onClick={() => setSelectedOption(options.id)}>
      <div style={{ padding: "5% 5% 10% 5%" }}>
        <div style={{ padding: "23% 23% 10% 23%" }}>{options.icon}</div>
        <CardText selected={selected}>{options.text}</CardText>
      </div>
    </Wrapper>
  );
}
